import Vue from 'vue'
import Vuex from 'vuex'
import templateDetails from '@/store/templateDetails'
import mainAuth from '@/store/mainAuth'
import translation from '@/store/translation'
import clientConfig from '@/store/clientConfig'
import documentsStore from '@/store/documentsStore'
import documentToolsStore from '@/store/documentToolsStore'
import userProfileStore from '@/store/userProfileStore'
import usersOnline from '@/store/usersOnline'
import viewLogsStore from '@/store/viewLogsStore'
import siteSetupStore from '@/store/siteSetupStore'
import businessUnitsStore from '@/store/businessUnitsStore'
import manageBatchesStore from '@/store/manageBatchesStore'
import batchInsertStore from '@/store/batchInsertStore'
import deliveryReportsStore from '@/store/deliveryReportsStore'
import coreTypesStore from '@/store/coreTypesStore'
import importDataFileStore from '@/store/importDataFileStore'
import manageCustomersStore from '@/store/manageCustomersStore'
import addressBookStore from '@/store/addressBookStore'
import widgetsStore from '@/store/widgetsStore'
import homepageStore from '@/store/homepageStore'
import menuBuilderStore from '@/store/menuBuilderStore'
import endUsersAdminLogonsStore from '@/store/endUsersAdminLogonsStore'
import manageRegistrationRequest from '@/store/manageRegistrationRequest'
import docTypeMappingStore from '@/store/docTypeMappingStore'
import emailVariablesStore from '@/store/emailVariablesStore'
import tokenTranslationStore from '@/store/tokenTranslationStore'
import principalStore from '@/store/principalStore'
import broadcastMessageStore from '@/store/broadcastMessageStore'
import customerStore from '@/store/customerStore'
import onlinePaymentStore from '@/store/onlinePaymentStore' // NS-9511 DL - new functionality for online payments
import batchRulesStore from '@/store/batchRulesStore'
import faqStore from '@/store/faqStore'
import clientDeliveryRulesStore from '@/store/clientDeliveryRulesStore' //ALL-9834 RR
import emailNotificationsStore from '@/store/emailNotificationsStore' // NS-9661 SP
import tokenStore from '@/store/tokenStore'
import downloadDataStore from '@/store/downloadDataStore' // NS-9951, PW
import billingDataStore from '@/store/billingDataStore' // NS-9886, PW
import postingStore from '@/store/posting' // NS-10090, VS
import invoicing from '@/store/invoicing' // NS-10708, VS
import termsStore from '@/store/termsStore' // NS-10645, PW
import mailsortStore from '@/store/mailsortStore' // NS-10357, PW
import sendExceptionsStore from '@/store/sendExceptionsStore'
import clientSettingsStore from '@/store/clientSettingsStore' // NS-11295 PW
import reportingStore from '@/store/reporting' // NS-10715 PW
import disputeStore from '@/store/disputeStore'
import integrationStore from '@/store/integrationStore' // NETSEND-8, PW


Vue.use(Vuex)

let store = new Vuex.Store({
  modules:{
    templateDetails,
    mainAuth,
    translation,
    clientConfig,
    documentsStore,
    documentToolsStore,
    userProfileStore,
    usersOnline,
    viewLogsStore,
    siteSetupStore,
    businessUnitsStore,
    manageBatchesStore,
    batchInsertStore,
    deliveryReportsStore,
    coreTypesStore,
    importDataFileStore,
    manageCustomersStore,
    addressBookStore,
    widgetsStore,
    homepageStore,
    menuBuilderStore,
    endUsersAdminLogonsStore,
    manageRegistrationRequest,
    docTypeMappingStore,
    emailVariablesStore,
    tokenTranslationStore,
    principalStore,
    broadcastMessageStore,
    customerStore,
	  onlinePaymentStore, // NS-9511 DL - new functionality for online payments
    batchRulesStore,
    faqStore,
    clientDeliveryRulesStore, //ALL-9834 RR
    emailNotificationsStore, // NS-9661 SP
    tokenStore,
    downloadDataStore, // NS-9951 PW
    billingDataStore, // NS-9886 PW
    postingStore,
    invoicing,
    termsStore, // NS-10645 PW
    mailsortStore, // NS-10357 PW
    sendExceptionsStore,
    clientSettingsStore, // NS-11295 PW
    reportingStore,
    disputeStore,
    integrationStore // NETSEND-8, PW
  }
})

export default store
